<template>
  <div>
    <div
      class="mt-3 mb-4 field-of-fields"
      style="width: 75%; display: block; margin-left: auto; margin-right: auto"
    >
      <a href="https://www.goldcoastnannies.company/">
        <img
          src="../../assets/img/logo/GoldCoastNannies_Logo_FullColor-01.png"
          width=""
          height=""
          :alt="$store.getters.agencyName"
          style="max-height: 60px; max-width: 75vw;"
          id=""
          class="center"
        />
      </a>
      <h1 class="center mt-5">Nanny Application Form</h1>
      <!-- <div class="mt-3 center">
        <p>Not sure if you are ready to go ahead?</p>
        <div style="margin-top: 18px; margin-bottom: 30px;">
          <a href="" class="mylisting-button dark-button" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/sarah-goldcoastnannies/15min'});return false;">Book a Call With Us</a>
        </div>
      </div> -->

      <hr />
      <label style="margin-top: 0">Which city are you applying to?*</label>
      <div
        class="form-check pl-4"
        v-for="(city, index) in $store.getters.cities"
        :key="'City' + index"
      >
        <input
          class="form-check-input"
          type="radio"
          :value="city"
          v-model="applicationCity"
        />
        <label class="form-check-label ml-1" for="cityRadios">
          {{ city }}
        </label>
      </div>
      <h3 style="" class="mt-4">Personal Information</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px" />
      <!-- <label>Family Name*</label> -->
      <!-- <input type="text" class="form-control" placeholder="eg. Smith" v-model="familyName"> -->
      <!-- <label style="color: red; margin-top: 3px;" v-if="!familyName && submitClicked">This field is required.</label> -->
      <!-- <p class="required-message" v-if="!familyName && submitClicked">This field is required.</p> -->
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>First Name*</label>
            <input type="text" class="form-control" v-model="motherFirst" />
            <p class="required-message" v-if="!motherFirst && submitClicked">
              This field is required.
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Last Name*</label>
            <input type="text" class="form-control" v-model="motherLast" />
            <p class="required-message" v-if="!motherLast && submitClicked">
              This field is required.
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Email Address*</label>
            <input
              type="text"
              class="form-control"
              v-model="motherEmail"
              placeholder=""
            />
            <p class="required-message" v-if="!motherEmail && submitClicked">
              This field is required.
            </p>
            <p
              class="required-message"
              v-if="motherEmail && validEmailFormat.test(motherEmail) === false"
            >
              Please enter a valid email.
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Phone Number*</label>
            <input
              type="text"
              class="form-control"
              v-model="motherPhone"
              placeholder="Please include area code."
            />
            <p class="required-message" v-if="!motherPhone && submitClicked">
              This field is required.
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <label>City*</label>
          <input type="text" class="form-control" v-model="city" />
          <p class="required-message" v-if="!city && submitClicked">
            This field is required.
          </p>
        </div>
        <div class="col-lg-4">
          <label>State*</label>
          <input type="text" class="form-control" v-model="state" />
          <p class="required-message" v-if="!state && submitClicked">
            This field is required.
          </p>
        </div>
        <div class="col-lg-4">
          <div>
            <label>Zip Code*</label>
            <input type="text" class="form-control" v-model="postalCode" />
            <p class="required-message" v-if="!postalCode && submitClicked">
              This field is required.
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <!-- <label>Age*</label>
          <input type="text" class="form-control" v-model="age" placeholder="">
          <p class="required-message" v-if="!age && submitClicked">This field is required.</p> -->
          <label>Date of Birth*</label>
          <!-- <input type="text" class="form-control" v-model="birthday1"> -->
          <!-- https://github.com/charliekassel/vuejs-datepicker/pull/163 -->
          <datepicker
            class="form-control"
            initial-view="year"
            v-model="birthday"
            style="padding: 0.37rem 0.75rem; line-height: 1"
          ></datepicker>
          <p class="required-message" v-if="!birthday && submitClicked">
            This field is required.
          </p>
        </div>
        <div class="col-lg-6"></div>
      </div>

      <!-- <label>Which is the best and most prompt way we can get into contact with you?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Email" v-model="preferredComm">
        <label class="form-check-label ml-1" for="exampleRadios1">
          Email
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Phone" v-model="preferredComm">
        <label class="form-check-label ml-1" for="exampleRadios2">
          Phone
        </label>
      </div>
      <p class="required-message" v-if="!preferredComm && submitClicked">This field is required.</p> -->

      <h3 style="" class="mt-5">Professional Information</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px" />
      <label
        >Years of Experience (Must have at least 2 years of relevant
        experience)*</label
      >
      <!-- <small>Must have at least 2 years of relevant experience</small> -->
      <div
        class="form-check pl-4"
        v-for="(experienceOption, index) in experienceOptions"
        :key="'Experience' + index"
      >
        <input
          class="form-check-input"
          type="radio"
          :value="experienceOption"
          v-model="experience"
        />
        <label class="form-check-label ml-1" for="experienceRadios">
          {{ experienceOption }}
        </label>
      </div>
      <p class="required-message" v-if="!experience && submitClicked">
        This field is required.
      </p>

      <label style="">Position(s) Applying For* (Check all that apply)</label>
      <div
        class="form-check"
        v-for="(position, index) in positionsOptions"
        :key="'Position' + index"
      >
        <input
          class="form-check-input"
          type="checkbox"
          :value="position"
          v-model="positions"
        />
        <label class="form-check-label">{{ position }}</label>
      </div>
      <p class="required-message" v-if="!positions.length && submitClicked">
        This field is required.
      </p>

      <label>Commitment*</label>
      <div
        class="form-check pl-4"
        v-for="(commitmentOption, index) in commitmentOptions"
        :key="'Commitment' + index"
      >
        <input
          class="form-check-input"
          type="radio"
          :value="commitmentOption"
          v-model="commitment"
        />
        <label class="form-check-label ml-1" for="commitmentRadios">
          {{ commitmentOption }}
        </label>
      </div>
      <div v-if="commitment == 'Short Term (1 year or less)'">
        <label style=""
          >Please explain why you are choosing short term (most of our positions
          are long term)</label
        >
        <input
          type="text"
          class="form-control"
          v-model="commitmentExplanation"
        />
      </div>
      <p class="required-message" v-if="!commitment && submitClicked">
        This field is required.
      </p>

      <label style="">Availability* (Check all that apply)</label>
      <div
        class="form-check"
        v-for="(availabilityOption, index) in availabilityOptions"
        :key="'Availability' + index"
      >
        <input
          class="form-check-input"
          type="checkbox"
          :value="availabilityOption"
          v-model="availability"
        />
        <label class="form-check-label">{{ availabilityOption }}</label>
      </div>
      <p class="required-message" v-if="!availability.length && submitClicked">
        This field is required.
      </p>

      <label style=""
        >Ideal Schedule* (Please note how many hours you would like)</label
      >
      <input type="text" class="form-control" v-model="schedule" />
      <p class="required-message" v-if="!schedule && submitClicked">
        This field is required.
      </p>

      <label style="">Fluent in any other languages?*</label>
      <input type="text" class="form-control" v-model="languages" />
      <p class="required-message" v-if="!languages && submitClicked">
        This field is required.
      </p>

      <label style="">Why did your last position end?*</label>
      <textarea rows="4" class="form-control" v-model="whyEnd"></textarea>
      <p class="required-message" v-if="!whyEnd && submitClicked">
        This field is required.
      </p>

      <div class="row">
        <div class="col-lg-6">
          <label style="">Pay range per hour*</label>
          <input type="text" class="form-control" v-model="payRange" />
          <p class="required-message" v-if="!payRange && submitClicked">
            This field is required.
          </p>
        </div>
        <div class="col-lg-6">
          <label>Start Date*</label>
          <datepicker
            class="form-control"
            v-model="startDate"
            :disabled-dates="disabledDates"
            style="padding: 0.37rem 0.75rem; line-height: 1"
          ></datepicker>
          <p class="required-message" v-if="!startDate && submitClicked">
            This field is required.
          </p>
        </div>
      </div>

      <label>Do you have a valid Driver's License and Car?*</label>
      <div
        class="form-check pl-4"
        v-for="(drivingStatusOption, index) in drivingStatuses"
        :key="'DrivingStatus' + index"
      >
        <input
          class="form-check-input"
          type="radio"
          :value="drivingStatusOption"
          v-model="drivingStatus"
        />
        <label class="form-check-label ml-1" for="drivingstatusRadios">
          {{ drivingStatusOption }}
        </label>
      </div>
      <p class="required-message" v-if="!drivingStatus && submitClicked">
        This field is required.
      </p>

      <label>Are you CPR and First Aid certified?*</label>
      <div
        class="form-check pl-4"
        v-for="(certificationStatusOption, index) in certificationStatuses"
        :key="'certificationStatusOption' + index"
      >
        <input
          class="form-check-input"
          type="radio"
          :value="certificationStatusOption"
          v-model="certificationStatus"
        />
        <label class="form-check-label ml-1" for="certificationStatusRadios">
          {{ certificationStatusOption }}
        </label>
      </div>
      <p class="required-message" v-if="!certificationStatus && submitClicked">
        This field is required.
      </p>

      <label>Are you up to date on vaccinations?*</label>
      <div
        class="form-check pl-4"
        v-for="(vaccinationStatusOption, index) in vaccinationStatuses"
        :key="'vaccinationStatus' + index"
      >
        <input
          class="form-check-input"
          type="radio"
          :value="vaccinationStatusOption"
          v-model="vaccinationStatus"
        />
        <label class="form-check-label ml-1" for="vaccinationStatusRadios">
          {{ vaccinationStatusOption }}
        </label>
      </div>
      <p class="required-message" v-if="!vaccinationStatus && submitClicked">
        This field is required.
      </p>

      <label style="">OK with pets in the home? (Check all that apply)</label>
      <div
        class="form-check"
        v-for="(petsOption, index) in petsOptions"
        :key="'petsOption' + index"
      >
        <input
          class="form-check-input"
          type="checkbox"
          :value="petsOption"
          v-model="pets"
        />
        <label class="form-check-label">{{ petsOption }}</label>
      </div>
      <!-- <p class="required-message" v-if="!positions.length && submitClicked">This field is required.</p> -->

      <label style="">Ok with travel? (Check all that apply)</label>
      <div
        class="form-check"
        v-for="(travelOption, index) in travelOptions"
        :key="'travelOption' + index"
      >
        <input
          class="form-check-input"
          type="checkbox"
          :value="travelOption"
          v-model="travel"
        />
        <label class="form-check-label">{{ travelOption }}</label>
      </div>
      <!-- <p class="required-message" v-if="!positions.length && submitClicked">This field is required.</p> -->

      <label>Are you legally able to work in the United States?*</label>
      <div
        class="form-check pl-4"
        v-for="(yesNoOption, index) in yesNoOptions"
        :key="'yesNoOption1' + index"
      >
        <input
          class="form-check-input"
          type="radio"
          :value="yesNoOption"
          v-model="legalStatus"
        />
        <label class="form-check-label ml-1" for="yesNoOptionsRadios">
          {{ yesNoOption }}
        </label>
      </div>
      <p class="required-message" v-if="!legalStatus && submitClicked">
        This field is required.
      </p>

      <label>Are you comfortable being paid legally?*</label>
      <div
        class="form-check pl-4"
        v-for="(yesNoOption, index) in yesNoOptions"
        :key="'yesNoOption2' + index"
      >
        <input
          class="form-check-input"
          type="radio"
          :value="yesNoOption"
          v-model="legalPay"
        />
        <label class="form-check-label ml-1" for="yesNoOptionsRadios">
          {{ yesNoOption }}
        </label>
      </div>
      <p class="required-message" v-if="!legalPay && submitClicked">
        This field is required.
      </p>

      <label style="">Do you have a valid Social Security Number?*</label>
      <input type="text" class="form-control" v-model="socialSecurity" />
      <p class="required-message" v-if="!socialSecurity && submitClicked">
        This field is required.
      </p>

      <h3 style="" class="mt-5">References</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px" />
      <p
        v-if="references.length < 3"
        style="font-size: 0.8rem; margin-top: 12px"
      >
        You must have at least 2 references.
      </p>
      <button
        class="mylisting-button dark-button mt-3 mb-3"
        @click="showReferenceModal()"
      >
        Add Reference
      </button>
      <div
        v-for="(reference, index) in references"
        :key="'Reference' + index"
        class="px-2"
      >
        <h5>Reference #{{ index + 1 }}</h5>
        <h5 style="font-weight: 600; margin-bottom: 0">
          Name: {{ reference.firstName }} {{ reference.lastName }}
          <!-- <img v-if="editAccess" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="float: right; cursor: pointer;" @click="showReferenceModal(reference)"> -->
        </h5>
        <div class="row" style="margin-top: -10px">
          <div class="col-lg-3" v-if="reference.relationship">
            <label>Relationship</label>
            <p>{{ reference.relationship }}</p>
          </div>
          <div class="col-lg-3" v-if="reference.phone">
            <label>Mobile Phone</label>
            <p>{{ reference.phone }}</p>
          </div>
          <!-- <div class="col-lg-3">
            <label v-if="reference.phone2">Other Phone</label>
            <p>{{ reference.phone2 }}</p>
          </div> -->
          <div class="col-lg-3" v-if="reference.email">
            <label>Email</label>
            <p>{{ reference.email }}</p>
          </div>
        </div>
        <!-- <hr style="margin-bottom: 0;"> -->
        <div class="row">
          <div class="col-lg-12">
            <label v-if="reference.description">Description</label>
            <pre>{{ reference.description }}</pre>
          </div>
        </div>
        <p
          @click="showReferenceModal(index)"
          class="mt-3"
          style="cursor: pointer"
        >
          Edit Reference
        </p>
        <hr />
      </div>
      <p
        class="required-message"
        style=""
        v-if="references.length < 2 && submitClicked"
      >
        You must have at least 2 references.
      </p>

      <h3 style="" class="mt-5">Documents</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px" />

      <label style="margin-bottom: 4px"
        >Nanny Resume (Make sure your resume highlights your nanny and other
        childcare experience) (Word doc or PDF only please!)</label
      >
      <input
        type="file"
        class="form-control-file"
        style="font-size: 0.8rem"
        id="resume"
        ref="resume"
        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        v-on:change="handleFileUpload($event, 'resume', 'doc')"
        :disabled="resumeDisabled"
      />
      <label
        >Experience* (If you do not have a resume, please use this space to list
        your previous experience including ages of children, job
        responsibilities, why it ended, etc. If you attached a resume above
        please write "see resume")</label
      >
      <textarea
        rows="4"
        class="form-control"
        v-model="experienceDescription"
      ></textarea>
      <p
        class="required-message"
        v-if="!experienceDescription && submitClicked"
      >
        This field is required.
      </p>

      <label style="margin-bottom: 4px">
        Please upload a headshot of yourself (PNG or JPG ONLY please!)*
      </label>
      <input
        type="file"
        class="form-control-file"
        style="font-size: 0.8rem"
        id="profile_pic"
        ref="profile_pic"
        accept="image/png,image/x-png,image/jpeg"
        v-on:change="handleFileUpload($event, 'profilePic', 'image')"
        :disabled="profilePicDisabled"
      />
      <p class="required-message" v-if="!profilePic && submitClicked">
        This field is required and must be a valid image file.
      </p>

      <label style="margin-bottom: 4px">
        Letter(s) of recommendation (Word doc or PDF only please!)
      </label>
      <input
        type="file"
        class="form-control-file"
        style="font-size: 0.8rem"
        id="recommendation_letters"
        ref="recommendation_letters"
        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        v-on:change="handleFileUpload($event, 'recommendationLetters', 'doc')"
        :disabled="recommendationLettersDisabled"
      />
      <!-- <p class="required-message" v-if="!recommendationLetters && submitClicked">This field is required.</p> -->

      <label style="margin-bottom: 4px">
        Additional Letter(s) of recommendation (Word doc or PDF only please!)
      </label>
      <input
        type="file"
        class="form-control-file"
        style="font-size: 0.8rem"
        id="recommendation_letters2"
        ref="recommendation_letters2"
        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        v-on:change="handleFileUpload($event, 'recommendationLetters2', 'doc')"
        :disabled="recommendationLetters2Disabled"
      />

      <label style="margin-bottom: 4px">
        Additional Letter(s) of recommendation (Word doc or PDF only please!)
      </label>
      <input
        type="file"
        class="form-control-file"
        style="font-size: 0.8rem"
        id="recommendation_letters3"
        ref="recommendation_letters3"
        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        v-on:change="handleFileUpload($event, 'recommendationLetters3', 'doc')"
        :disabled="recommendationLetters3Disabled"
      />

      <label style="margin-bottom: 4px">
        Attach a photo of your driver's license or government issued card (PNG
        or JPG ONLY please!)*
      </label>
      <input
        type="file"
        class="form-control-file"
        style="font-size: 0.8rem"
        id="government_id"
        ref="government_id"
        accept="image/png,image/x-png,image/jpeg"
        v-on:change="handleFileUpload($event, 'governmentID', 'image')"
        :disabled="governmentIDDisabled"
      />
      <p class="required-message" v-if="!governmentID && submitClicked">
        This field is required.
      </p>

      <div class="" style="margin-top: 30px; margin-bottom: 80px">
        <div style="display: block">
          <button
            class="mylisting-button dark-button"
            style="float: right"
            @click="submitApplication()"
          >
            Submit
          </button>
        </div>
      </div>
      <div style="margin-bottom: 130px">
        <p v-if="requiredMissing" class="required-message" style="float: right">
          A required field is missing, please check the form.
        </p>
      </div>
    </div>

    <modal
      name="reference-modal"
      width="90%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5 field-of-fields">
        <h3 v-if="!editingReference">Add Reference</h3>
        <h3 v-if="editingReference">
          Edit Reference - {{ reference.firstName }} {{ reference.lastName }}
        </h3>
        <hr style="margin-bottom: 0" />
        <div class="row">
          <div class="col-lg-6 px-4 mb-4">
            <label>First Name*</label>
            <input
              type="text"
              class="form-control"
              v-model="referenceFirstName"
            />
            <label>Last Name*</label>
            <input
              type="text"
              class="form-control"
              v-model="referenceLastName"
            />
            <label>Relation</label>
            <small style="display: block" class="mb-1"
              >Ex. Babysitting Family, Nanny Family, Summer Camp Director</small
            >
            <input
              type="text"
              class="form-control"
              v-model="referenceRelationship"
            />
            <label>Mobile Phone*</label>
            <input type="text" class="form-control" v-model="referencePhone" />
            <!-- <label>Other Phone</label>
            <input type="text" class="form-control" v-model="phone2"> -->
            <label>Email</label>
            <input type="text" class="form-control" v-model="referenceEmail" />
            <p
              class="required-message"
              style=""
              v-if="
                referenceEmail &&
                validEmailFormat.test(referenceEmail) === false
              "
            >
              Please enter a valid email.
            </p>
          </div>
          <div class="col-lg-6 px-4">
            <!-- <label>Number of Children Cared for*</label>
            <input type="text" class="form-control" v-model="numChildren">
            <label>Ages of Children When Hired*</label>
            <input type="text" class="form-control" v-model="ageChildren">
            <label>Specific Number of Years Worked With Them*</label>
            <small style="display: block;" class="mb-1">Ex. 3 years, 2012-2015</small>
            <input type="text" class="form-control" v-model="years">
            <label>How Frequently Did You Work For Them?*</label>
            <small style="display: block;" class="mb-1">Ex. Casual Babysitting 1-2x/month, Part-time Nanny 3 days/week</small>
            <input type="text" class="form-control" v-model="frequency"> -->
            <label
              >Describe your experience (children cared for, length of time
              worked, etc.)*</label
            >
            <textarea
              rows="5"
              class="form-control"
              v-model="referenceDescription"
            ></textarea>
          </div>
        </div>
        <hr />
        <div>
          <button
            class="mylisting-button secondary-button"
            @click="$modal.hide('reference-modal')"
          >
            Cancel
          </button>
          <button
            v-if="editingReference"
            class="mylisting-button danger-button mt-1"
            @click="showDeleteReferenceModal()"
            style=""
          >
            Delete
          </button>
          <button
            v-if="
              !editingReference &&
              referenceFirstName &&
              referenceLastName &&
              (referencePhone ||
                (referenceEmail && validEmailFormat.test(referenceEmail))) &&
              (!referenceEmail ||
                (referenceEmail && validEmailFormat.test(referenceEmail)))
            "
            class="mylisting-button dark-button mt-1 mb-4"
            @click="addReference()"
            style="float: right"
          >
            Add
          </button>
          <button
            v-if="
              editingReference &&
              referenceFirstName &&
              referenceLastName &&
              (referencePhone ||
                (referenceEmail && validEmailFormat.test(referenceEmail))) &&
              (!referenceEmail ||
                (referenceEmail && validEmailFormat.test(referenceEmail)))
            "
            class="mylisting-button dark-button mt-1 mb-4"
            @click="updateReference()"
            style="float: right"
          >
            Update
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="required-missing-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <h2>A required field is missing.</h2>
        <h4>Please review the form for error messages!</h4>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('required-missing-modal')"
          style=""
        >
          Close
        </button>
      </div>
    </modal>

    <modal
      name="duplicate-email-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <!-- <h2>Your email is already in our system!</h2> -->
        <h2>Sorry, there was an error processing your application!</h2>
        <!-- <h4>Have you worked with us before? If you think this is an error, please contact us: sarah@goldcoastnannies.company</h4> -->
        <h4>
          It's possible your email is already in our system, have you worked
          with us before? If not, we may be experiencing a high load at the
          moment, please keep this page open and wait a couple of minutes and
          try clicking submit again. If the error persists, please contact us:
          {{ $store.getters.enginehireAdminEmail }}
        </h4>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('duplicate-email-modal')"
          style=""
        >
          Close
        </button>
      </div>
    </modal>

    <modal
      name="application-submitted-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <h2>Thank you for submitting your application!</h2>
        <h5>
          We will review it and get in touch if we have the right role for you.
          You can safely close this window.
        </h5>
        <!-- <h4>You can safely close this window.</h4> -->
        <!-- <p>Not sure if you are ready to go ahead?</p> -->
        <!-- <div style="margin-top: 20px; margin-bottom: 30px;">
          <a href="" class="mylisting-button dark-button" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/sarah-goldcoastnannies/15min'});return false;">Book a Call With Us</a>
        </div> -->
        <hr />
        <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('application-submitted-modal')" style="">Close</button> -->
        <button
          class="mylisting-button secondary-button"
          @click="hideApplicationSubmittedModal()"
          style=""
        >
          Close
        </button>
      </div>
    </modal>

    <modal
      name="delete-reference-modal"
      width="50%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <label>Are you sure you want to delete this reference?</label>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('delete-reference-modal')"
          style=""
        >
          Close
        </button>
        <button
          class="mylisting-button danger-button"
          @click="deleteReference()"
          style=""
        >
          Delete
        </button>
      </div>
    </modal>

    <modal
      name="document-error-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <h2>Your application has been submitted! BUT</h2>
        <h5>
          There was an error uploading your documents. Can you please email them
          to sarah@goldcoastnannies.company? Thanks!
        </h5>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('document-error-modal')"
          style=""
        >
          Close
        </button>
      </div>
    </modal>

    <modal
      name="invalid-image-file-type-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <h2>Sorry, that file type is invalid!</h2>
        <h5>Please upload a PNG or JPG image.</h5>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('invalid-image-file-type-modal')"
          style=""
        >
          Close
        </button>
      </div>
    </modal>

    <modal
      name="invalid-doc-file-type-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <h2>Sorry, that file type is invalid!</h2>
        <h5>Please upload a DOC or DOCX or PDF file.</h5>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('invalid-doc-file-type-modal')"
          style=""
        >
          Close
        </button>
      </div>
    </modal>

    <modal
      name="reference-error-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <h2>Your application has been submitted! BUT</h2>
        <h5>
          There was an error processing your references. Can you please email
          them to sarah@goldcoastnannies.company? Thanks!
        </h5>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('reference-error-modal')"
          style=""
        >
          Close
        </button>
      </div>
    </modal>

    <modal
      name="invalid-file-size-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999"
    >
      <div class="p-5">
        <h2>Sorry, that file is invalid!</h2>
        <h5>Please upload a non empty file</h5>
        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('invalid-file-size-modal')"
          style=""
        >
          Close
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
// import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
import Datepicker from "vuejs-datepicker"; // https://www.npmjs.com/package/vuejs-datepicker

// import References from './ApplicationReferences'

import Bugsnag from '@bugsnag/js'

export default {
  components: {
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
    // References,
  },
  data() {
    return {
      applicationCity: "Chicago",

      familyName: "",
      motherFirst: "",
      motherLast: "",
      motherEmail: "",
      motherPhone: "",
      // fatherFirst: '',
      // fatherLast: '',
      // fatherEmail: '',
      // fatherPhone: '',
      address: "",
      city: "",
      state: "",
      postalCode: "",
      age: "",
      birthday: null,

      experience: "",
      positions: [],
      commitment: "",
      commitmentExplanation: "",
      availability: [],
      schedule: "",
      languages: "",
      whyEnd: "",
      payRange: "",
      startDate: null,
      drivingStatus: "",
      certificationStatus: "",
      vaccinationStatus: "",
      pets: [],
      travel: [],
      legalStatus: "",
      legalPay: "",
      socialSecurity: "",

      references: [],
      reference: {},
      editingReference: false,
      referenceIndex: "",
      referenceFirstName: "",
      referenceLastName: "",
      referenceRelationship: "",
      referencePhone: "",
      referenceEmail: "",
      referenceDescription: "",

      resume: "",
      experienceDescription: "",
      profilePic: "",
      recommendationLetters: "",
      recommendationLetters2: "",
      recommendationLetters3: "",
      governmentID: "",

      resumeDisabled: false,
      profilePicDisabled: false,
      recommendationLettersDisabled: false,
      recommendationLetters2Disabled: false,
      recommendationLetters3Disabled: false,
      governmentIDDisabled: false,

      // experienceOptions: ['2-5 years', '5-10 years', '10 plus years'],
      // experienceOptions: [],

      submitClicked: false,
      requiredMissing: false,

      // resource: https://www.w3resource.com/javascript/form/email-validation.php
      // regex to check for valid email string
      validEmailFormat: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      invalidEmail: false,

      acceptedImageTypes: ["image/jpeg", "image/png"],
      acceptDocTypes: [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ],
    };
  },
  computed: {
    disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      let today = new Date();
      let disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      };
      return disabledDates;
    },
  },
  created() {
    window.location.href = 'https://nanniescoasttocoast.enginehire.io/application-form/20/207';

    this.experienceOptions = this.$store.getters.experienceOptions;
    this.positionsOptions = this.$store.getters.positions;
    this.commitmentOptions = this.$store.getters.commitmentOptions;
    this.availabilityOptions = this.$store.getters.availabilityOptions;
    this.drivingStatuses = this.$store.getters.drvingStatuses;
    this.certificationStatuses = this.$store.getters.certificationStatuses;
    this.vaccinationStatuses = this.$store.getters.vaccinationStatuses;
    this.petsOptions = this.$store.getters.petsOptions;
    this.travelOptions = this.$store.getters.travelOptions;
    this.yesNoOptions = this.$store.getters.yesNoOptions;
  },
  methods: {
    showReferenceModal(index) {
      // console.log(index);
      if (index || index === 0) {
        let reference = this.references[index];
        this.referenceFirstName = reference.firstName;
        this.referenceLastName = reference.lastName;
        this.referenceRelationship = reference.relationship;
        this.referencePhone = reference.phone;
        this.referenceEmail = reference.email;
        this.referenceDescription = reference.description;
        this.referenceIndex = index;
        this.editingReference = true;
        this.$modal.show("reference-modal");
      } else {
        this.$modal.show("reference-modal");
        this.referenceFirstName = "";
        this.referenceLastName = "";
        this.referenceRelationship = "";
        this.referencePhone = "";
        this.referenceEmail = "";
        this.referenceDescription = "";
        this.referenceIndex = "";
        this.editingReference = false;
      }
    },
    addReference() {
      let reference = {};
      reference.firstName = this.referenceFirstName;
      reference.lastName = this.referenceLastName;
      reference.relationship = this.referenceRelationship;
      reference.phone = this.referencePhone;
      reference.email = this.referenceEmail;
      reference.description = this.referenceDescription;
      if (
        this.validEmailFormat.test(this.referenceEmail) === true ||
        this.referencePhone
      ) {
        this.references.push(reference);
        this.$modal.hide("reference-modal");
      }
    },
    updateReference() {
      if (
        this.validEmailFormat.test(this.referenceEmail) === true ||
        this.referencePhone
      ) {
        this.references[
          this.referenceIndex
        ].firstName = this.referenceFirstName;
        this.references[this.referenceIndex].lastName = this.referenceLastName;
        this.references[
          this.referenceIndex
        ].relationship = this.referenceRelationship;
        this.references[this.referenceIndex].phone = this.referencePhone;
        this.references[this.referenceIndex].email = this.referenceEmail;
        this.references[
          this.referenceIndex
        ].description = this.referenceDescription;
        this.$modal.hide("reference-modal");
      }
    },
    handleFileUpload(event, model, fileType) {
      const uploadFile = event.target.files[0];
      if (uploadFile) {
        if(uploadFile.size === 0) {
           this.$modal.show("invalid-file-size-modal");
            this[model] = "";
            event.target.value = "";
            return;
        }
        if (fileType === "image") {
          if (!this.acceptedImageTypes.includes(uploadFile["type"])) {
            this.$modal.show("invalid-image-file-type-modal");
            this[model] = "";
            event.target.value = "";
            return;
          }
        } else if (fileType === "doc") {
          if (!this.acceptDocTypes.includes(uploadFile["type"])) {
            this.$modal.show("invalid-doc-file-type-modal");
            this[model] = "";
            event.target.value = "";
            return;
          }
        }
        this[model] = uploadFile;
      }
    },
    submitApplication() {
      // For some reason on mobile Safari, if the user missed something when submitting the application, the files would not upload
      // This is an attempt to put the files back into place before submitting
      if (this.$refs.resume.files[0]) {
        this.resume = this.$refs.resume.files[0]
      }
      if (this.$refs.profile_pic.files[0]) {
        this.profilePic = this.$refs.profile_pic.files[0];
      }
      if (this.$refs.recommendation_letters.files[0]) {
        this.recommendationLetters = this.$refs.recommendation_letters.files[0]
      }
      if (this.$refs.recommendation_letters2.files[0]) {
        this.recommendationLetters2 = this.$refs.recommendation_letters2.files[0]
      }
      if (this.$refs.recommendation_letters3.files[0]) {
        this.recommendationLetters3 = this.$refs.recommendation_letters3.files[0]
      }
      if (this.$refs.government_id.files[0]) {
        this.governmentID = this.$refs.government_id.files[0]
      }

      // It seems on mobile Safari there can be a problem caused by unfilled inputs, so this is meant to disable them if unfilled
      // https://stackoverflow.com/questions/51201011/ios-safari-fails-to-send-form-data-via-ajax/51273135
      // https://stackoverflow.com/questions/38085180/how-to-disable-input-conditionally-in-vue-js
      if (!this.resume) {
        this.resumeDisabled = true
      }
      if (!this.profilePic) {
        this.profilePicDisabled = true
      }
      if (!this.recommendationLetters) {
        this.recommendationLettersDisabled = true
      }
      if (!this.recommendationLetters2) {
        this.recommendationLetters2Disabled = true
      }
      if (!this.recommendationLetters3) {
        this.recommendationLetters3Disabled = true
      }
      if (!this.governmentID) {
        this.governmentIDDisabled = true
      }

      // this.$modal.show('application-submitted-modal')
      this.submitClicked = true;
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

      if (this.validEmailFormat.test(this.motherEmail) === false) {
        this.invalidEmail = true;
      } else {
        this.invalidEmail = false;
      }

      if (
        this.applicationCity &&
        this.motherFirst &&
        this.motherLast &&
        this.motherEmail &&
        this.motherPhone &&
        this.city &&
        this.state &&
        this.postalCode &&
        this.birthday && // this.age &&
        this.experience &&
        this.positions.length &&
        this.commitment &&
        this.availability.length &&
        this.schedule &&
        this.languages &&
        this.whyEnd &&
        this.payRange &&
        this.startDate &&
        this.drivingStatus &&
        this.certificationStatus &&
        this.vaccinationStatus &&
        this.legalStatus &&
        this.legalPay &&
        this.socialSecurity &&
        this.references.length >= 2 &&
        this.experienceDescription &&
        this.profilePic &&
        this.governmentID &&
        this.invalidEmail === false
      ) {
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide();
        }, 10000);

        // axios.post('/create-user/', {
        //   email: this.motherEmail,
        //   password: this.motherEmail,
        // })
        //   .then(res => {
        //     console.log('User resgistered!')
        //     console.log(res)
        //     console.log(res.data.pk)

        //     console.log(this.$store.getters.agencyID)
        //     console.log(this.$store.getters.agencyName)

        //     axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
        //       {
        //         agency: this.$store.getters.agencyID,
        //         agency_owner: this.$store.getters.agencyName,
        //         is_employer: true,
        //         status: 'Applied',
        //       }
        //     )
        //       .then(res => {
        //         console.log(res)
        //       })
        //       .catch(error => console.log(error))
        //   })
        //   .catch(error => console.log(error))

        this.$store
          .dispatch("registerUser", {
            email: this.motherEmail,
            password: this.motherEmail,
            user_type: "candidate",
            status: "Applied",
            phone: this.motherPhone,
          })
          .then(() => {
            console.log("Done registration");
            // Send myself an email notification that a new client started a quote
            this.$store.dispatch("sendEmails", {
              subject: "New Nanny Application",
              message:
                "New nanny application form submitted by: " +
                this.motherFirst +
                " " +
                this.motherLast +
                " | " +
                this.motherEmail +
                "\nPlease log into the administrator dashboard to view it!",
              from: this.$store.getters.agencyFromEmail,
              // emails: [this.$store.getters.enginehireAdminEmail],
              emails: [
                this.$store.getters.enginehireLoggingEmail,
                this.$store.getters.agencyAdminEmail,
                this.$store.getters.agencyAdminEmail2,
              ],
              reply: this.$store.getters.agencyReplyEmail,
              // userID: this.aakashid,
              userID: 4,
            });

            this.$modal.show("application-submitted-modal");
            this.patchDetails();

            // if (this.startDate) {
            //   this.startDate = new Date(this.startDate)
            //   this.startDate = this.dateInDjangoFormat(this.startDate)
            // }
            // if (this.birthday) {
            //   this.birthday = new Date(this.birthday)
            //   this.birthday = this.dateInDjangoFormat(this.birthday)
            // }

            // // Need to store all the contact info after creating the user
            // axios.patch('/api/people/'+this.$store.getters.userID.toString()+'/', {
            //   // selector1: 'Permanent',
            //   // employer_name: this.familyName,
            //   first_name: this.motherFirst,
            //   last_name: this.motherLast,
            //   phone: this.motherPhone,
            //   // features: [this.fatherFirst, this.fatherLast],
            //   // address1: this.address,
            //   postal_code: this.postalCode,
            //   city: this.city,
            //   provincestate: this.state,
            //   // text1: this.age,
            //   date1: this.birthday,

            //   selector1: this.experience,
            //   sectors: this.positions,
            //   selector2: this.commitment,
            //   text2: this.commitmentExplanation,
            //   preferences: this.availability,
            //   text3: this.schedule,
            //   text4: this.languages,
            //   text5: this.whyEnd,
            //   text6: this.payRange,
            //   available_date: this.startDate,

            //   selector3: this.drivingStatus,
            //   selector4: this.certificationStatus,
            //   selector5: this.vaccinationStatus,
            //   preferences2: this.pets,
            //   preferences3: this.travel,
            //   selector6: this.legalStatus,
            //   selector7: this.legalPay,
            //   text7: this.socialSecurity,

            //   text8: this.experienceDescription,

            //   selector8: this.applicationCity,
            // })
            //   .then(res => {
            //     console.log(res)

            //     let formData = new FormData();
            //     if (this.profilePic) {
            //       formData.append("profile_pic", this.profilePic);
            //     }
            //     if (this.resume) {
            //       formData.append("resume", this.resume);
            //     }
            //     if (this.recommendationLetters) {
            //       formData.append("file1", this.recommendationLetters);
            //     }
            //     if (this.governmentID) {
            //       formData.append("file2", this.governmentID);
            //     }

            //     axios.patch("/api/people/".concat(this.$store.getters.userID.toString()).concat("/"),
            //       formData,
            //       {
            //         headers: {
            //           "Content-Type": "multipart/form-data"
            //         }
            //       }
            //     )
            //     .then(res => {
            //       console.log(res);
            //       this.$modal.show('application-submitted-modal')
            //       // this.$store.dispatch('logout', 'no-redirect')
            //     })
            //     .catch(error => {
            //       console.log(error)
            //       // this.$modal.show('document-error-modal')
            //     })

            //     for(var reference in this.references) {
            //       axios.post('/api/references/', {
            //         user: this.$store.getters.userID,
            //         first_name: this.references[reference].firstName,
            //         last_name: this.references[reference].lastName,
            //         relationship: this.references[reference].relationship,
            //         phone: this.references[reference].phone,
            //         // phone2: this.phone2,
            //         email: this.references[reference].email,
            //         text1: this.references[reference].description,
            //       })
            //         .then(res => {
            //           console.log(res)
            //         })
            //         .catch(error => {
            //           console.log(error)
            //           this.$modal.show('reference-error-modal')
            //           this.$modal.hide('application-submitted-modal')
            //         })
            //     }
            //   })
            //   .catch(error => {
            //     console.log(error)
            //   })
          })
          .catch((error) => {
            console.log(error);
            this.$modal.show("duplicate-email-modal");

            this.$store.dispatch("sendEmails", {
              subject: "FAILED Nanny Application",
              message:
                "FAILED Nanny Application submitted by: " +
                this.motherFirst +
                " " +
                this.motherLast +
                " | " +
                this.motherEmail +
                `first_name: ${this.firstName},
                last_name: ${this.lastName},
                phone: ${this.phone}`,
              from: this.$store.getters.agencyFromEmail,
              emails: [
                this.$store.getters.enginehireAdminEmail,
                this.$store.getters.enginehireLoggingEmail
              ],
              reply: this.$store.getters.agencyReplyEmail,
              // userID: this.aakashid,
              userID: 4,
            });
          });
      } else {
        this.resumeDisabled = false
        this.profilePicDisabled = false
        this.recommendationLettersDisabled = false
        this.recommendationLetters2Disabled = false
        this.recommendationLetters3Disabled = false
        this.governmentIDDisabled = false

        // this.requiredMissing = true
        this.$modal.show("required-missing-modal");
      }
    },
    patchDetails() {
      if (this.startDate) {
        this.startDate = new Date(this.startDate);
        this.startDate = this.dateInDjangoFormat(this.startDate);
      }
      if (this.birthday) {
        this.birthday = new Date(this.birthday);
        this.birthday = this.dateInDjangoFormat(this.birthday);
      }

      // Need to store all the contact info after creating the user
      axios
        .patch("/api/people/" + this.$store.getters.userID.toString() + "/", {
          // selector1: 'Permanent',
          // employer_name: this.familyName,
          first_name: this.motherFirst,
          last_name: this.motherLast,
          phone: this.motherPhone,
          // features: [this.fatherFirst, this.fatherLast],
          // address1: this.address,
          postal_code: this.postalCode,
          city: this.city,
          provincestate: this.state,
          // text1: this.age,
          date1: this.birthday,

          selector1: this.experience,
          sectors: this.positions,
          selector2: this.commitment,
          text2: this.commitmentExplanation,
          preferences: this.availability,
          text3: this.schedule,
          text4: this.languages,
          text5: this.whyEnd,
          text6: this.payRange,
          available_date: this.startDate,

          selector3: this.drivingStatus,
          selector4: this.certificationStatus,
          selector5: this.vaccinationStatus,
          preferences2: this.pets,
          preferences3: this.travel,
          selector6: this.legalStatus,
          selector7: this.legalPay,
          text7: this.socialSecurity,

          text8: this.experienceDescription,

          selector8: this.applicationCity,
          locations: [this.applicationCity],
        })
        .then((res) => {
          console.log(res);

          console.log(this.profilePic)
          console.log(this.resume)
          console.log(this.recommendationLetters)
          console.log(this.recommendationLetters2)
          console.log(this.recommendationLetters3)
          console.log(this.governmentID)

          let formData = new FormData();
          if (this.profilePic !== "") {
            formData.append("profile_pic", this.profilePic);
          }
          if (this.resume !== "") {
            formData.append("resume", this.resume);
          }
          if (this.recommendationLetters !== "") {
            formData.append("file1", this.recommendationLetters);
          }
          if (this.recommendationLetters2 !== "") {
            formData.append("file3", this.recommendationLetters2);
          }
          if (this.recommendationLetters3 !== "") {
            formData.append("file4", this.recommendationLetters3);
          }
          if (this.governmentID !== "") {
            formData.append("file2", this.governmentID);
          }

          console.log(formData)

          // this.$store.dispatch("sendEmails", {
          //   subject: "Nanny Application File Upload",
          //   message:
          //     "New nanny application form submitted by: " +
          //     this.motherFirst +
          //     " " +
          //     this.motherLast +
          //     " | " +
          //     this.motherEmail +
          //     " | " +
          //     formData +
          //     "\nPlease log into the administrator dashboard to view it!",
          //   from: this.$store.getters.agencyFromEmail,
          //   // emails: [this.$store.getters.enginehireAdminEmail],
          //   emails: [
          //     this.$store.getters.enginehireAdminEmail
          //   ],
          //   reply: this.$store.getters.agencyReplyEmail,
          //   // userID: this.aakashid,
          //   userID: 4,
          // });

          axios
            .patch(
              "/api/people/"
                .concat(this.$store.getters.userID.toString())
                .concat("/"),
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              console.log(res);
              // this.$modal.show('application-submitted-modal')
              // this.$store.dispatch('logout', 'no-redirect')
              // Bugsnag.notify(new Error(`Application document submitted - ${this.motherFirst} ${this.motherLast} ${this.$store.getters.userID} | profile_pic: ${this.profilePic} resume: ${this.resume} recommendationLetters: ${this.recommendationLetters} recommendationLetters2: ${this.recommendationLetters2} recommendationLetters3: ${this.recommendationLetters3} governmentID: ${this.governmentID}`))
            })
            .catch((error) => {
              console.log(error);
              // this.$modal.show('document-error-modal')
              if (error && error.response && error.response.data) {
                Bugsnag.notify(new Error(`Application document error - ${JSON.stringify(error.response.data)} ${this.motherFirst} ${this.motherLast} ${this.$store.getters.userID} | profile_pic: ${this.profilePic} resume: ${this.resume} recommendationLetters: ${this.recommendationLetters} recommendationLetters2: ${this.recommendationLetters2} recommendationLetters3: ${this.recommendationLetters3} governmentID: ${this.governmentID}`))
              } else {
                Bugsnag.notify(new Error(`Application document error - ${error} ${this.motherFirst} ${this.motherLast} ${this.$store.getters.userID} | profile_pic: ${this.profilePic} resume: ${this.resume} recommendationLetters: ${this.recommendationLetters} recommendationLetters2: ${this.recommendationLetters2} recommendationLetters3: ${this.recommendationLetters3} governmentID: ${this.governmentID}`))
              }
            });

          for (var reference in this.references) {
            axios
              .post("/api/references/", {
                user: this.$store.getters.userID,
                first_name: this.references[reference].firstName,
                last_name: this.references[reference].lastName,
                relationship: this.references[reference].relationship,
                phone: this.references[reference].phone,
                // phone2: this.phone2,
                email: this.references[reference].email,
                text1: this.references[reference].description,
              })
              .then((res) => {
                console.log(res);
              })
              .catch((error) => {
                console.log(error);
                // this.$modal.show('reference-error-modal')
                // this.$modal.hide('application-submitted-modal')
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });

      // let formData = new FormData();
      // if (this.profilePic) {
      //   formData.append("profile_pic", this.profilePic);
      // }
      // if (this.resume) {
      //   formData.append("resume", this.resume);
      // }
      // if (this.recommendationLetters) {
      //   formData.append("file1", this.recommendationLetters);
      // }
      // if (this.recommendationLetters2) {
      //   formData.append("file3", this.recommendationLetters2);
      // }
      // if (this.recommendationLetters3) {
      //   formData.append("file4", this.recommendationLetters3);
      // }
      // if (this.governmentID) {
      //   formData.append("file2", this.governmentID);
      // }

      // axios.patch("/api/people/".concat(this.$store.getters.userID.toString()).concat("/"),
      //   formData,
      //   {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     }
      //   }
      // )
      // .then(res => {
      //   console.log(res);
      //   // this.$modal.show('application-submitted-modal')
      //   // this.$store.dispatch('logout', 'no-redirect')
      // })
      // .catch(error => {
      //   console.log(error)
      //   // this.$modal.show('document-error-modal')
      // })

      // for (var reference in this.references) {
      //   axios.post('/api/references/', {
      //     user: this.$store.getters.userID,
      //     first_name: this.references[reference].firstName,
      //     last_name: this.references[reference].lastName,
      //     relationship: this.references[reference].relationship,
      //     phone: this.references[reference].phone,
      //     // phone2: this.phone2,
      //     email: this.references[reference].email,
      //     text1: this.references[reference].description,
      //   })
      //     .then(res => {
      //       console.log(res)
      //     })
      //     .catch(error => {
      //       console.log(error)
      //       // this.$modal.show('reference-error-modal')
      //       // this.$modal.hide('application-submitted-modal')
      //     })
      // }
    },

    hideApplicationSubmittedModal() {
      // window.location.href = 'https://www.goldcoastnannies.company/';
      window.location.href = this.$store.getters.website;
    },
    showDeleteReferenceModal() {
      this.$modal.show("delete-reference-modal");
    },
    deleteReference() {
      this.references.splice(this.referenceIndex, 1);
      this.$modal.hide("reference-modal");
      this.$modal.hide("delete-reference-modal");
    },
  },
};
</script>

<style>
.required-field {
  color: red !important;
  font-weight: 600 !important;
}
.required-message {
  color: red;
  font-family: "Open Sans", "Crimson Text";
  font-weight: 600;
  margin-top: 2px;
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/candidates/ApplicationForm.vue